<script lang="ts">
  import Modal from "$lib/components/Modal.svelte";
  import { navigate } from "$lib/router.svelte";

  let { open = $bindable(false), reason = "limit" } = $props<{
    open?: boolean;
    reason?: "members" | "transactions" | "storage" | "rules" | "limit";
  }>();

  const messages: Record<string, { title: string; body: string }> = {
    members:      { title: "Adicione mais pessoas ao time", body: "O plano FREE permite até 2 membros. No PRO você adiciona até 8." },
    transactions: { title: "Você atingiu 500 transações no mês", body: "Continue lançando sem limites com o plano PRO." },
    storage:      { title: "Espaço de comprovantes esgotado", body: "PRO oferece 5 GB e BUSINESS 50 GB para anexos." },
    rules:        { title: "Limite de regras automáticas", body: "PRO permite até 50 regras; BUSINESS é ilimitado." },
    limit:        { title: "Recurso disponível em planos pagos", body: "Faça upgrade para liberar." },
  };
  let m = $derived(messages[reason] ?? messages.limit);
</script>

<Modal bind:open title={m.title}>
  <p class="text-sm">{m.body}</p>
  <ul class="text-sm space-y-1 mt-3">
    <li>✅ Transações ilimitadas</li>
    <li>✅ Até 8 membros + papéis (PRO) / 50 (BUSINESS)</li>
    <li>✅ Recorrência, parcelamento, regras automáticas</li>
    <li>✅ Exportações PDF/XLSX/OFX</li>
    <li>✅ Suporte prioritário</li>
  </ul>
  {#snippet footer()}
    <button class="btn-ghost" onclick={() => (open = false)}>Agora não</button>
    <button class="btn-primary" onclick={() => { open = false; navigate("/pricing"); }}>
      Ver planos
    </button>
  {/snippet}
</Modal>
